import type { PublicProfileData } from "../types/public-profile-data";

import { create } from "zustand";

import { ReviewsData } from "@/features/profile/public/types/reviews.ts";

interface PublicProfileStore {
  profileData: PublicProfileData | null;
  setProfileData: (data: PublicProfileData) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  reviewsData: ReviewsData | null;
  setReviewsData: (data: ReviewsData) => void;
  reviewPage: number;
  setReviewPage: (page: number) => void;
}

export const usePublicProfileStore = create<PublicProfileStore>((set) => ({
  profileData: null,
  setProfileData: (data) => set({ profileData: data }),
  isLoading: true,
  setIsLoading: (isLoading) => set({ isLoading }),
  reviewsData: null,
  setReviewsData: (data) => set({ reviewsData: data }),
  reviewPage: 1,
  setReviewPage: (page: number) => set({ reviewPage: page }),
}));
